import styled from 'styled-components';
import {
    compose,
    branch,
    withProps,
    mapProps,
    setDisplayName,
    setPropTypes,
} from 'react-recompose';

import { oneOf } from 'prop-types';
import { fieldPropTypes } from 'redux-form';
import { Field } from 'redux-form/immutable';
import {
    Form,
    Input,
    Select,
    TextArea,
    Checkbox,
    Dropdown,
} from 'semantic-ui-react';


const withMappedProps = mapProps(({
    input: {
        onChange,
        onBlur,
        ...input
    },
    meta: {
        touched,
        error,
    },
    ...rest
}) => ({
    ...input,
    ...rest,
    onChange: (_, { value }) => onChange(value),
    onBlur: () => onBlur(),
    error: Boolean(touched && error),
    message: touched ? error : '',
}));

const withMappedCheckboxProps = mapProps(({
    input: {
        value,
        onChange,
        ...input
    },
    meta,
    ...rest
}) => ({
    ...input,
    ...rest,
    checked: value || false,
    indeterminate: (typeof value !== 'boolean'),
    onChange: (_, { checked }) => onChange(checked),
}));


const StyledFormField = styled(Form.Field)`
    && {
        ::after {
            display: block;
            margin-left: 2px;
            margin-top: 2px;
            margin-bottom: 10px;
            content: '${p => p.message }';
            font-size: 12px;
            color: #9F3A38;
        }
    }
`;

/*
 * Integration Form.Field and Redux-Form
 */
const FormField = compose(
    setDisplayName('FormField'),
    setPropTypes({
        control: oneOf([
            Form.Input,
            Form.Select,
            Form.TextArea,
            Form.Checkbox,
            Input,
            Select,
            TextArea,
            Checkbox,
            Dropdown,
        ]).isRequired,
        ...fieldPropTypes,
    }),
    branch(
        ({ control }) => (control === Checkbox || control === Form.Checkbox),
        withMappedCheckboxProps,
        withMappedProps,
    ),
)(StyledFormField);

export default withProps({ component: FormField })(Field);
